export const getCountryInitials = (country: string) => {
    const uppercaseCountry = country.toUpperCase()
    switch (uppercaseCountry) {
        case "COTE D'IVOIRE":
        case "CÔTE D'IVOIRE":
            return 'CI'
        case 'SENEGAL':
            return 'SN'
        case 'MALI':
            return 'ML'
        default:
            return uppercaseCountry
    }
}
